import {Link} from "react-router";
import {
	DefaultPolicyName,
	UserPermissionEntityType,
	UserPermissionItemResponse,
	UserPermissionRole,
} from "libs/apiClient";
import client from "libs/client";
import { useToast } from "ui-kit";

export function UserPermissionsTable({
	userPermissions,
	deletable = false,
}: {
	userPermissions: UserPermissionItemResponse[],
	deletable?: boolean,
}) {
	const { addErrorToast, addSuccessToast } = useToast();

	const permissionDescription = (up: UserPermissionItemResponse) => {
		if (up.entityType === UserPermissionEntityType.enum["team" as const]) {
			return `${up.policyName === DefaultPolicyName.enum["member"  as const] ? "Member": (up.policyName === DefaultPolicyName.enum["admin" as const] ? "Admin" : "")} in Team`
		}
		if (up.entityType === 'club_house') {
			return `${up.policyName === "member" ? "Member": (up.policyName === DefaultPolicyName.enum["admin" as const] ? "Admin" : "")} in ClubHouse`
		}
		if (up.entityType === UserPermissionEntityType.enum["player" as const]) {
			if (up.role === UserPermissionRole.enum["player" as const]) {
				return `Player`
			}
			if (up.role === UserPermissionRole.enum["parent"as const]) {
				return `Parent of player`
			}
		}

		return '';
	}

	const isDeletable = (up: UserPermissionItemResponse) => {
		return up.entityType === UserPermissionEntityType.enum["player" as const]
			&& up.role === UserPermissionRole.enum["player" as const];
	}

	const deleteDiscoverUserPermissionMutation = client.deleteDiscoverUserPermission.useMutation({
		onSuccess: () => {
			addSuccessToast("Permission deleted");
			client.queryClient.invalidateQueries({
				predicate: (query) => query.queryKey.includes("discoverUserDetail"),
			});
			close();
		},
		onError: (res) => {
			if (res.status !== 403) {
				addErrorToast(res.message);
			}
		},
	});

	const handleDelete = (userPermissionId: number) => {
		if (!confirm("Are you sure you know what you are doing?")) {
			return;
		}
		deleteDiscoverUserPermissionMutation.mutate({ id: userPermissionId });
	}

	if (userPermissions.length === 0) {
		return <div className="empty-sub-table">No permissions</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>User entity and role</th>
					<th>User</th>
					<th>Club House</th>
					<th>Team</th>
					<th>Player</th>
					{deletable && <th>&nbsp;</th>}
				</tr>
			</thead>
			<tbody>
				{userPermissions.map((up: UserPermissionItemResponse, index) => (
					<tr key={`row-${index}`}>
						<td>{up.id}</td>
						<td>
							{permissionDescription(up)}
						</td>
						<td>
							{up.user && <Link to={`/discover/user/${up.user.id}`}><strong>{up.user.name}</strong></Link>}
						</td>
						<td>
							{up.clubHouse && <Link to={`/discover/club/${up.clubHouse.id}`}>{up.clubHouse.name} {(up.clubHouse.metadata?.["appDisabled"] || false) && (<small style={{fontWeight: "bold", fontSize: "10px"}}>{" (app disabled)"}</small>)}</Link>}
						</td>
						<td>
							{up.team && <Link to={`/discover/team/${up.team.id}`}>{up.team.name} {(up.team?.metadata?.["appDisabled"] || false) && (<small style={{fontWeight: "bold", fontSize: "10px"}}>{" (app disabled)"}</small>)}</Link>}
						</td>
						<td>
							{up.player && up.playerData && <Link to={`/discover/player-data/${up.playerData.id}`}>{up.player.name}</Link>}
						</td>
						{deletable && <td>
							{isDeletable(up) && <span
								className="admin-button admin-button--danger admin-button--xs"
								onClick={() => handleDelete(up.id)}
							>&times;</span>}
						</td>}
					</tr>
				))}
			</tbody>
		</table>
	)
}
